import cacheKeys from '@/data/api/cacheKeys';
import { getDetailOrders } from '@/data/api/request/orderDetailRequests';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';

export function useGetDetailOrders(args: {
  page?: number;
  orderNumber?: string;
  dateRange?: [Date, Date];
  sellerIds?: string[];
  statusId?: string;
  remissionStatusId?: string;
  kamIds?: string[];
}) {
  let dateRangeFormated: [string, string] | undefined;
  if (args.dateRange) {
    dateRangeFormated = [
      dayjs(args.dateRange[0]).format('YYYY-MM-DD'),
      dayjs(args.dateRange[1]).format('YYYY-MM-DD'),
    ];
  }

  const { data, error, isLoading } = useQuery({
    queryKey: [
      cacheKeys.detailOrder.list,
      {
        page: args.page,
        orderId: args.orderNumber,
        dateRange: dateRangeFormated,
        sellerIds: args.sellerIds,
        statusId: args.statusId,
        remissionStatusId: args.remissionStatusId,
        kamIds: args.kamIds,
      },
    ],
    queryFn: () =>
      getDetailOrders({
        pageNumber: args.page,
        orderNumber: args.orderNumber,
        dateRange: dateRangeFormated,
        sellerIds: args.sellerIds,
        statusId: args.statusId,
        remissionStatusId: args.remissionStatusId,
        kamIds: args.kamIds,
      }),
  });

  return {
    data,
    error,
    isLoading,
  };
}
